{
  "Accessibility Menu": "Мени За Приступачност",
  "Reset settings": "Ресетуј поставке",
  "Close": "Затвори",
  "Content Adjustments": "Подешавање Садржаја",
  "Adjust Font Size": "Подешавање Величине Фонта",
  "Highlight Title": "Означи Наслове",
  "Highlight Links": "Означи Везе",
  "Readable Font": "Читљивији Фонт",
  "Color Adjustments": "Подешавање Боја",
  "Dark Contrast": "Тамни Контраст",
  "Light Contrast": "Свијетли Контраст",
  "High Contrast": "Високи Контраст",
  "High Saturation": "Велика Засићеност",
  "Low Saturation": "Ниска Засићеност",
  "Monochrome": "Једнобојни",
  "Tools": "Алати",
  "Reading Guide": "Водич За Читање",
  "Stop Animations": "Заустави Анимације",
  "Big Cursor": "Велики Курсор",
  "Increase Font Size": "Повећај Величину Фонта",
  "Decrease Font Size": "Смањи Величину Фонта",
  "Letter Spacing": "Размак Слова",
  "Line Height": "Висина Линије",
  "Font Weight": "Дебљина Фонта",
  "Dyslexia Font": "Фонт За Дислексичаре",
  "Language": "Језик",
  "Open Accessibility Menu": "Отвори Мени За Приступачност"
}
